import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** Deletes a document. */
export const executeDelete = store.effects.create(
  (feature: Feature) =>
    feature.actions.delete.request.observe().pipe(
      rxjs.exhaustMap(action =>
        feature.api.deleteFile(action.data.target).pipe(
          rxjs.map(response =>
            feature.actions.delete.success.from(action).create({
              request: action.data,
              response,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.delete.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
